"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const IdHeader_1 = __importDefault(require("../../../components/IdHeader"));
const IllustrationBackgroundTop_1 = __importDefault(require("../../../components/illustrations/IllustrationBackgroundTop"));
const SmilingEmailIllu_1 = __importDefault(require("../../../components/illustrations/SmilingEmailIllu"));
const Success = () => {
    return (react_1.default.createElement("div", { className: "email-confirm-success" },
        react_1.default.createElement(IllustrationBackgroundTop_1.default, null),
        react_1.default.createElement(IdHeader_1.default, { handlerFunction: function () {
                throw new Error("Function not implemented.");
            } }),
        react_1.default.createElement("div", { className: "email-confirm-success__container" },
            react_1.default.createElement("div", { className: "email-confirm-success__content" },
                react_1.default.createElement("h1", { className: "email-confirm-success__title" }, "Sikeresen meger\u0151s\u00EDtetted az email c\u00EDmed!")),
            react_1.default.createElement("div", { className: "email-confirm-success__illustration" },
                react_1.default.createElement(SmilingEmailIllu_1.default, null)))));
};
exports.default = Success;
if (document.getElementById("core-confirm-success")) {
    (0, client_1.createRoot)(document.getElementById("core-confirm-success")).render(react_1.default.createElement(Success, null));
}
